import styled, { css } from 'styled-components'

export const Container = styled.div``

export const RadioButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  transition: all 0.2s linear;
  border-radius: 8px;

  svg {
    font-size: 16px;
    path {
      fill: #C4C4C4;
    }
  }

  span {
    margin-left: 10px;
  }

  ${({ active }) => active && css`
    svg {
      path {
        fill: #AAFF26;
      }
    }
  `}

  &:hover {
    background-color: #222430;
  }
`
